import { render } from "./SideBarNavigation.vue?vue&type=template&id=6da9e420&scoped=true"
import script from "./SideBarNavigation.vue?vue&type=script&lang=js"
export * from "./SideBarNavigation.vue?vue&type=script&lang=js"

import "./SideBarNavigation.vue?vue&type=style&index=0&id=6da9e420&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da9e420"]])

export default __exports__